import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  FormControlLabel,
  Grid,
  InputAdornment,
  RadioGroup,
  Typography,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ValidationError, number, object, string } from "yup";
import styles from "../devoteeService.module.scss";
import commonStyles from "../../../App.module.scss";
import { isBoolean, isNil } from "lodash";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import IconButton from "@mui/material/IconButton";
import cartIcon from "../../../assets/svg/Cart.svg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import constants from "../../../config/constants.json";
import {
  CustomSelect,
  CustomMenuItem,
  CustomLeftIcon,
  CustomCloseIcon,
  CommonOutlinedButton,
  CommonButton,
  CustomBadge,
  CustomInputLabel,
  CustomTextFeild,
  CustomRadioButton,
  CustomRequiredInputLabel,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import CalendarPurchase from "../Calendar/calendarPurchase";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserDetails,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import {
  cartItemListProps,
  prasadamListProps,
} from "../../../infrastructure/GlobalContextProvider";
import LOCALE from "../../../config/en-us.json";
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { CartComponent } from "../../common/cartItemsComponent/cartComponent";

interface FormDataTypes {
  username: string;
  prasadam: string;
  quantity: number;
  amount: number;
  suggestedDonationamount: number;
  id?: number | undefined | null;
}

type ErrorDataTypes = {
  username: string;
  prasadam: string;
  quantity: string;
  amount: string;
  suggestedDonationamount: string;
};

interface PurchaseProps {
  showHeaders?: boolean;
  username: string;
  onBackClick?: () => void;
}

const Purchase = (props: PurchaseProps) => {
  const [selectedValue, setSelectedValue] = useState("Prasadam");
  const [formData, setFormData] = useState({
    username: props.username || "",
    prasadam: "",
    quantity: 1,
    amount: 0,
    suggestedDonationamount: 0,
  });
  const [errorMessage, setErrorMessage] = useState<ErrorDataTypes>({
    username: "",
    prasadam: "",
    quantity: "",
    amount: "",
    suggestedDonationamount: "",
  });
  const [addedItemsList, setAddedItemsList] = useState<FormDataTypes[]>([]);
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showList, setShowList] = useState<boolean>(false);
  const [prasadamList, setPrasadamList] = useState<prasadamListProps[]>([]);
  const [quantityList, setQuantityList] = useState<number[]>([]);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [donationId, setDonationId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showRadioButtons, setRadioButtons] = useState<boolean>(true);

  const getHeaders = (): boolean => {
    if (
      !isNil(props.showHeaders) &&
      isBoolean(props.showHeaders) &&
      props.showHeaders === false
    ) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.prasadamList,
      includeToken: true,
    })
      .then((res) => {
        setPrasadamList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.quantityList,
      includeToken: true,
    })
      .then((res) => {
        setQuantityList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);

  const validationSchema = object().shape({
    // username: string().required("Name is required"),
    prasadam: string().required("Prasadam is required"),
    quantity: number().required("Quantity is required"),
    amount: string()
      .required("Amount is required")
      .test(
        "is-number",
        "Amount must be a valid number",
        (value) => !isNaN(parseFloat(value))
      ),
    suggestedDonationamount: number()
      .required("Donation amount is required")
      .min(1, "Minimum donation amount is 1")
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      }),
  });

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: props.username,
      },
    })
      .then((res) => {
        setcartItemsList(res.data.bookedItemInCart);
        setTotalDonationAmount(res.data.totalAmount);
        setShowList(false);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const addToCartApiCall = () => {
    const reqBody = {
      onBehalfOfUsername: formData.username,
      purchaseType: formData.prasadam,
      quantity: formData.quantity,
      amount: formData.suggestedDonationamount,
      donationsPurposeId: donationId,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.purchaseApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        setFormData({
          username: props.username || "",
          prasadam: "",
          quantity: 1,
          amount: 0,
          suggestedDonationamount: 0,
        });
        setDonationId("");
        getCartItems();
        // toast.custom(<ToastSuccess message={LOCALE.ITEM_ADDED}/>)
        toast.custom(
          <SuccessPopup
            headerMessage="Items Added"
            showMessage={LOCALE.ITEM_ADDED}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "prasadam") {
      const selectedPrasadam = prasadamList.find(
        (item: prasadamListProps) => item.name === value
      );
      if (selectedPrasadam) {
        setFormData({
          ...formData,
          prasadam: selectedPrasadam.name,
          amount: selectedPrasadam.suggestedDonation,
          suggestedDonationamount: selectedPrasadam.suggestedDonation,
          quantity: 1, // Resetting quantity to initial value when prasadam changes
        });
        setDonationId(selectedPrasadam.donationPurposeId);
      }
    } else if (field === "quantity") {
      const newAmount = formData.amount * value;
      setFormData({
        ...formData,
        [field]: value,
        suggestedDonationamount: newAmount,
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };
  
  
  
  
  const PrasadamDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Prasadam"
          value={formData.prasadam}
          defaultValue=""
          id="prasadam"
          onChange={(e) => {
            handleFieldChange("prasadam", e.target.value);
            setErrorMessage({ ...errorMessage, prasadam: "", suggestedDonationamount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.prasadam ? styles.errorTextField : styles.textField
          }
        >
          {prasadamList.map((item: prasadamListProps, index: number) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.prasadam ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.prasadam}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const QuantityCount = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Quantity"
          value={formData.quantity}
          defaultValue=""
          id="quantity"
          onChange={(e) => {
            handleFieldChange("quantity", e.target.value);
            setErrorMessage({ ...errorMessage, quantity: "", suggestedDonationamount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.quantity ? styles.errorTextField : styles.textField
          }
        >
          {quantityList.map((item: number, index: number) => (
            <CustomMenuItem key={index} value={item}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.quantity ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.quantity}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const navigateBack = () => {
    getCartItems()
  };

  const handleAdd = async () => {
    const errors: ErrorDataTypes = {
      username: "",
      prasadam: "",
      quantity: "",
      amount: "",
      suggestedDonationamount: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert("Data is Here");
      console.log("added");

      // Call your API or perform other actions here
      // onClickAdd();
      addToCartApiCall();
    } catch (error) {
      // Handle validation errors
      console.log("err");

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorDataTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleClear = () => {
    setFormData({
      ...formData,
      prasadam: "",
      quantity: 1,
      amount: 0,
      suggestedDonationamount: 0,
    });
  };

  const tableDataComponent = () => {
    return (
      <div>
        <div className={styles.backArrow}>
          <div onClick={navigateBack} style={{ marginRight: "10px" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        {cartItemsList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                {/* <th className={styles.tableHorizontal}>Pooja Title</th> */}
                <th className={styles.tableHorizontal}>Deities</th>
                <th className={styles.tableHorizontal}>Date of Pooja</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>Suggested Donation Amount</th>
                <th className={styles.tableHorizontal}>Tangible Amount</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {cartItemsList.map((item: cartItemListProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item?.type}</td>
                  <td className={styles.tableDiagonal}>{item.priestName}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.deities?.map((diety) => (
                      <>
                        {diety}
                        <br />
                      </>
                    ))}
                  </td>
                  <td className={styles.tableDiagonal}>{item?.dateOfPooja}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.donationPurpose}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.amount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.tangibleAmount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      alt="delete icon"
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
        {cartItemsList.length > 0 && (
          <div className={styles.totalAmount}>
            <p>Total {formatAmount(totalDonationAmount)}</p>
          </div>
        )}
      </div>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };

  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      apiRequest({
        method: "DELETE",
        includeToken: true,
        endpoint: `${apiPath.deleteCartItem}/${selectedId}`,
      })
        .then((res) => {
          console.log(res.data);
          getCartItems();
          // Close the dialog
          handleClose();
          // toast.custom(<ToastSuccess message={LOCALE.ITEM_DELETED} />)
          toast.custom(
            <SuccessPopup
              headerMessage="Items Deleted"
              showMessage={LOCALE.ITEM_DELETED}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
             
            />
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <div className={styles.closeIcon} onClick={handleClose}>
          <CustomCloseIcon />
        </div>
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Item ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const listComponentAndPayment = () => {
    return (
      <>
        {getHeaders() ? (
          <Typography component="div" className={styles.typoGraphyHeading}>
            Devotee Service
          </Typography>
        ) : (
          ""
        )}
        <div style={{ width: "100%" }}>
          {tableDataComponent()}
          <ModeofPayment />
          {dialogPopup()}
        </div>
      </>
    );
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handleAdd();
    }
  };

  const renderPrasadComponent = () => {
    return (
      <>
        {/* {!getHeaders() ? <div className={styles.cartContainer}>
            <div className={styles.text}>Devotee Cart</div>
            <IconButton aria-label="cart" onClick={handleCart}>
              <CustomBadge
                badgeContent={cartItemsList.length}
                color="secondary"
              >
                <img src={cartIcon} />
              </CustomBadge>
            </IconButton>
          </div> : ""} */}
        <Card className={styles.cardContainer}>
          <form style={{ padding: "24px" }} onKeyDown={handleKeyPress}>
            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
              <Grid xs={12} sm={4} item >
                {CustomRequiredInputLabel("Name", true)}
                <CustomTextFeild
                id="name"
                  fullWidth
                  required
                  value={
                    getUserSelectedRole() === constants.MANAGER_ROLE ||
                    getUserSelectedRole() === constants.ADMINSTARTIVE_ASSISTANT_ROLE ||
                    getUserSelectedRole() === constants.FRONT_DESK_ROLE ||
                    getUserSelectedRole() === constants.OFFICE_STAFF_ROLE ||
                    getUserSelectedRole() === constants.FACILITIES_ROLE
                      ? getDevoteeId()?.fullName?.toUpperCase()
                      : getUserDetails()?.toUpperCase()
                  }
                  className={
                    errorMessage.username
                      ? styles.errorTextField
                      : styles.textField
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "0px" }} >
              <Grid xs={12} sm={4} item id="prasadam">
                {CustomRequiredInputLabel("Prasadam", true)}
                {PrasadamDropdown()}
              </Grid>
              <Grid xs={12} sm={4} item id="quantity">
                {CustomRequiredInputLabel("Quantity", true)}
                {QuantityCount()}
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
              <Grid xs={12} sm={4} item >
                <CustomInputLabel>
                  Suggested Donation Amount(in dollars)
                </CustomInputLabel>
                <CustomTextFeild
                id="suggestedDonationAmount"
                  fullWidth
                  required
                  value={formData.suggestedDonationamount}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^\d.]/g, '').slice(0, 10); // Allow only the first 10 numbers
                    handleFieldChange("suggestedDonationamount", numericValue);
                    setErrorMessage({
                      ...errorMessage,
                      suggestedDonationamount: "",
                    });
                  }}
                  className={
                    errorMessage.suggestedDonationamount
                      ? styles.errorTextField
                      : styles.textField
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyIcon fontSize="small" sx={{position:"absolute"}}/>
                      </InputAdornment>
                    ),
                    // readOnly: true,
                  }}
                />

                {errorMessage.suggestedDonationamount ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.suggestedDonationamount}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </form>
        </Card>
        <Box>
          <CommonOutlinedButton
            sx={{ marginTop: "10px", marginRight: "16px" }}
            onClick={handleClear}
            id="clear"
          >
            Clear
          </CommonOutlinedButton>
          <CommonButton
            sx={{ marginTop: "10px" }}
            onClick={handleAdd}
            disabled={loading}
            id="add"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Adding...
                </span>
              </>
            ) : (
              "Add"
            )}
          </CommonButton>
        </Box>
      </>
    );
  };

  const renderMainComponent = () => {
    return (
      <div className={styles.PrasadamPurchaseContainer}>
        <div className={styles.formContainer}>
          {getHeaders() ? (
            <Typography className={styles.typoGraphyHeading}>Purchase</Typography>
          ) : (
            ""
          )}
          <div
            className={styles.cartAndPurchaseTypes}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {showRadioButtons ? (
              <div>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={selectedValue}
                  onChange={handleRadioChange}
                  id="prasadamRadioButton"
                >
                  <FormControlLabel
                    control={
                      <CustomRadioButton
                        value="Prasadam"
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 10 } }}
                      />
                    }
                    label="Prasadam"
                  />
                  <FormControlLabel
                    control={
                      <CustomRadioButton
                        value="Calendar"
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 10 } }}
                      />
                    }
                    label="Calendar"
                  />
                </RadioGroup>
              </div>
            ) : (
              ""
            )}
           
              <div className={styles.cartContainer}>
                {!isNil(props.onBackClick) ? (
                  <CommonOutlinedButton
                    onClick={props.onBackClick}
                    sx={{ marginTop: "10px", marginRight: "10px" }}
                    id="backToSearch"
                  >
                    Back to Search Devotee
                  </CommonOutlinedButton>
                ) : (
                  ""
                )}
                <div className={styles.text}>Devotee Cart</div>
                <IconButton aria-label="cart" onClick={handleCart}>
                  <CustomBadge
                    badgeContent={cartItemsList.length}
                    color="secondary"
                  >
                    <img src={cartIcon} alt="cart"/>
                  </CustomBadge>
                </IconButton>
              </div>
            
          </div>
          {selectedValue === "Prasadam" ? (
            renderPrasadComponent()
          ) : (
            <CalendarPurchase
              username={props.username}
              onBackClick={props.onBackClick}
              setRadioButtons={setRadioButtons}
              handleCart={handleCart}
              getCartItems={getCartItems}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Toaster /> {!showList ? renderMainComponent() : <CartComponent navigateBack={navigateBack}/>}
    </>
  );
};
export default Purchase;
